import {getFeaturesUnionByReferences} from '@apps-common/geocorn-sdk/api/features';

export const hydrateSearchGeometry = async search => {
  if (search.geometry?.type === 'ref') {
    const hydratedGeo = await getFeaturesUnionByReferences(
      search.geometry.content
    );
    return {
      ...search,
      hydratedGeometry: hydratedGeo.geometry,
    };
  } else if (search.geometry) {
    return {
      ...search,
      hydratedGeometry: search.geometry,
    };
  } else {
    return search;
  }
};
